/* ═══════════════════════════════════════════════════════════════
   MAGIC CURSOR TRAIL — subtle pixie-dust following the cursor.
   Shared across all pages. Desktop pointers only; disabled on touch
   and prefers-reduced-motion. Self-contained (canvas styled inline),
   so it needs no page CSS. Set ENABLE_CURSOR_TRAIL = false to disable.
   ═══════════════════════════════════════════════════════════════ */
(function(){
  const ENABLE_CURSOR_TRAIL = true;             // ← flip to false to disable
  if (!ENABLE_CURSOR_TRAIL) return;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduce) return;                  // desktop pointers only

  const COLORS = ['255,255,255', '255,222,140', '206,180,242'];
  const canvas = document.createElement('canvas');
  canvas.className = 'cursor-trail';
  canvas.setAttribute('aria-hidden','true');
  canvas.style.cssText = 'position:fixed;inset:0;z-index:9998;pointer-events:none;';
  function attach(){ (document.body || document.documentElement).appendChild(canvas); }
  if (document.body) attach(); else document.addEventListener('DOMContentLoaded', attach);
  const ctx = canvas.getContext('2d');
  const dpr = Math.min(2, window.devicePixelRatio||1);
  function resize(){
    canvas.width = innerWidth*dpr; canvas.height = innerHeight*dpr;
    canvas.style.width = innerWidth+'px'; canvas.style.height = innerHeight+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  resize();
  window.addEventListener('resize', resize);

  const parts = [];
  let lastX=0, lastY=0, primed=false;
  window.addEventListener('mousemove', e => {
    if (!primed){ lastX=e.clientX; lastY=e.clientY; primed=true; return; }
    const dx=e.clientX-lastX, dy=e.clientY-lastY;
    const dist=Math.hypot(dx,dy);
    if (dist < 6) return;                        // spawn by distance = performant
    lastX=e.clientX; lastY=e.clientY;
    const n = Math.min(2, 1+(dist/40|0));
    for (let i=0;i<n;i++){
      parts.push({
        x: e.clientX + (Math.random()-0.5)*6,
        y: e.clientY + (Math.random()-0.5)*6,
        r: 0.8 + Math.random()*1.8,
        c: COLORS[(Math.random()*COLORS.length)|0],
        vx: (Math.random()-0.5)*0.4,
        vy: -0.2 - Math.random()*0.5,            // gentle upward drift
        life: 1
      });
    }
    if (parts.length > 320) parts.splice(0, parts.length-320);
  });

  function frame(){
    ctx.clearRect(0,0,innerWidth,innerHeight);
    for (let i=parts.length-1;i>=0;i--){
      const p = parts[i];
      p.life -= 0.013;                          // longer trail duration
      if (p.life <= 0){ parts.splice(i,1); continue; }
      p.x += p.vx; p.y += p.vy;
      ctx.beginPath();
      ctx.fillStyle = 'rgba('+p.c+','+(p.life*0.65).toFixed(3)+')';
      ctx.shadowBlur = p.r*3;
      ctx.shadowColor = 'rgba('+p.c+',0.5)';
      ctx.arc(p.x, p.y, p.r*p.life, 0, Math.PI*2);
      ctx.fill();
    }
    ctx.shadowBlur = 0;
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
